module.exports = __webpack_public_path__ + "static/hacibaba-sm-87ec767b8f362333977de9dedd0e7389.jpg";